import NotificationsSetupChoice from './notificationsSetupChoice/NotificationsSetupChoice.vue'
import { mapState } from 'vuex'
import config from '../../../config'

export default {
  name: 'NotificationsSetup',
  components: { NotificationsSetupChoice },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showEmail: config.ENABLE_EMAIL
    }
  },
  created() {
    this.$store.dispatch('getNotificationSetup')
  },
  methods: {
    allWebNotifs() {
      this.$store.dispatch('updateAllWebNotification')
    },
    noWebNotifs() {
      this.$store.dispatch('updateNoWebNotification')
    },
    allEmailNotifs() {
      this.$store.dispatch('updateAllEmailNotification')
    },
    noEmailNotifs() {
      this.$store.dispatch('updateNoEmailNotification')
    }
  },
  computed: {
    value() {
      return this.notificationSetup
    },
    notificationSetupForm() {
      return [
        {
          title: this.$t('user.notificationsSetup.fromMyCreatedCommunities'),
          enabled: true,
          notifications: [
            {
              description: this.$t('user.notificationsSetup.joinMyCommunity'),
              type: 'joinMyCommunity'
            },
            {
              description: this.$t('user.notificationsSetup.joinRequest'),
              type: 'joinRequest'
            }
          ]
        },
        {
          title: this.$t('user.notificationsSetup.fromMyCommunities'),
          enabled: true,
          notifications: [
            {
              description: this.$t('user.notificationsSetup.joinRequestAccepted'),
              type: 'joinRequestAccepted'
            },
            {
              description: this.$t('user.notificationsSetup.postInMyCommunity'),
              type: 'postInMyCommunity'
            },
            {
              description: this.$t('user.notificationsSetup.postInCommunityIJoined'),
              type: 'postInCommunityIJoined'
            }
          ]
        },
        {
          title: this.$t('user.notificationsSetup.fromMyPosts'),
          enabled: true,
          notifications: [
            {
              description: this.$t('user.notificationsSetup.likeMyPost'),
              type: 'likeMyPost'
            },
            {
              description: this.$t('user.notificationsSetup.commentMyPost'),
              type: 'commentMyPost'
            },
            {
              description: this.$t('user.notificationsSetup.commentPostICommented'),
              type: 'commentPostICommented'
            },
            {
              description: this.$t('user.notificationsSetup.commentPostIBookmarked'),
              type: 'commentPostIBookmarked'
            }
          ]
        },
        {
          title: this.$t('user.notificationsSetup.fromMyComments'),
          enabled: true,
          notifications: [
            {
              description: this.$t('user.notificationsSetup.likeMyComment'),
              type: 'likeMyComment'
            }
          ]
        },
        {
          title: this.$t('user.notificationsSetup.fromMentions'),
          enabled: true,
          notifications: [
            {
              description: this.$t('user.notificationsSetup.mentionedInPost'),
              type: 'mentionedInPost'
            },
            {
              description: this.$t('user.notificationsSetup.mentionedInComment'),
              type: 'mentionedInComment'
            }
          ]
        }
      ]
    },
    filteredSetupForm() {
      return this.notificationSetupForm.filter((notif) => {
        return notif.enabled
      })
    },
    ...mapState({
      notificationSetup: state => state.notification.notificationSetup
    })
  }
}
